import React, { useContext, useEffect, useState } from "react";
import HyperLogo from "../../Images/HyperLogo.png";
import styled from "styled-components";
import Clock from "./Clock";
import Player from "./Player";
import Subs from "../Subs/Subs";
import EndHalf from "./EndHalf";
import moment from "moment";
import { Button } from "../../Theme/Hyper";
import { UserContext } from "../../contexts/UserContext";
import Table from "./Table";
import { UIContext } from "../../contexts/UIContext";

const Main = styled.div`
  display: flex;

  align-items: center;
  width: 100%;
  padding-top: 0.5em;
  background-color: #202731;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
`;
const Logo = styled.img`
  height: auto;
  width: 50%;
`;
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const CurrentGraphic = styled.div`
  margin-top: auto;
  width: 100%;
  height: 167px;
  background-color: #181d25;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 12px;
  margin: 0px;
  padding-bottom: 10px;
`;
const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const NavButton = styled(Button)`
  margin: 0.5em;
  background-color: ${(props) => (props.selected ? "#0adb93" : "")};
  color: ${(props) => (props.selected ? "#1d1d1d" : "")};
`;

const Profile = styled.div`
  width: 100%;
  height: 35px;
  background-color: #202731;
  z-index: 1000;
  position: -webkit-sticky;
  position: sticky;
  box-shadow: 0px 4px 12px -20px rgb(0 0 0 / 20%),
    0px 8px 20px 2px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  border-bottom: 1px solid #030304;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  padding-bottom: 5px;
  margin-bottom: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
const Row = styled.div`
  display: flex;
  width: 100%;
`;
export default function RightSideBarStream({
  game,
  updateGame,
  previewGraphic,
  graphicInPreview,
  animateGraphic,
  animateOffGraphic,
  updateGraphic,
  teams,
  selectedPlayer,
  players,
  stadiums,
  sky,
  squads,
  countries,
  standings,
  kits,
  clearPreview,
}) {
  const { user, signOut } = useContext(UserContext);
  const { homeKit, awayKit } = useContext(UIContext);
  const [view, setView] = useState(0);

  return (
    <Main>
      {(window.ENV?.REACT_APP_AUTH || process.env.REACT_APP_AUTH) !==
        "false" && (
        <Profile>
          {user?.username}
          <Button
            style={{ border: "1px solid #fff", marginLeft: "auto" }}
            onClick={() => {
              signOut();
            }}
          >
            Sign Out
          </Button>
        </Profile>
      )}
      <Logo src={HyperLogo}></Logo>
      <Clock
        game={game}
        teams={teams}
        updateGame={updateGame}
        previewGraphic={previewGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        updateGraphic={updateGraphic}
        sky={sky}
      />
      <Buttons>
        <NavButton selected={view === 0} onClick={() => setView(0)}>
          PRE GAME
        </NavButton>
        <NavButton selected={view === 1} onClick={() => setView(1)}>
          IN GAME
        </NavButton>
        <NavButton selected={view === 2} onClick={() => setView(2)}>
          END GAME
        </NavButton>
      </Buttons>

      {selectedPlayer && (
        <Player
          player={selectedPlayer}
          game={game}
          previewGraphic={previewGraphic}
        />
      )}

      {view === 1 && !selectedPlayer && (
        <Column>
          Match Score
          <Buttons>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 1,
                  subtitle: "1st Quarter",
                });
              }}
            >
              Q1
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 2,
                  subtitle: "2nd Quarter",
                });
              }}
            >
              Q2
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 3,
                  subtitle: "3rd Quarter",
                });
              }}
            >
              Q3
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 4,
                  subtitle: "4th Quarter",
                });
              }}
            >
              Q4
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 5,
                  subtitle: "Extra Time",
                });
              }}
            >
              ET
            </NavButton>
          </Buttons>
        </Column>
      )}
      {view === 1 && !selectedPlayer && (
        <Column>
          Match Score End Q
          <Buttons>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 1,
                  subtitle: "End of 1st Quarter",
                });
              }}
            >
              Q1
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 2,
                  subtitle: "Half-Time",
                });
              }}
            >
              Q2
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 3,
                  subtitle: "End of 3rd Quarter",
                });
              }}
            >
              Q3
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 4,
                  subtitle: "End of 4th Quarter",
                });
              }}
            >
              Q4
            </NavButton>
            <NavButton
              onClick={() => {
                previewGraphic("Score", {
                  game: game,
                  period: 5,
                  subtitle: "End of Extra Time",
                });
              }}
            >
              ET
            </NavButton>
          </Buttons>
        </Column>
      )}
      {view === 1 && !selectedPlayer && (
        <GraphicButton
          onClick={() => {
            previewGraphic("Score", {
              game: game,
              period: 4,
              subtitle: "Final Score",
            });
          }}
        >
          Match Final Score
        </GraphicButton>
      )}

      {view === 1 && !selectedPlayer && (
        <GraphicButton
          onClick={() => {
            previewGraphic("TeamCrawl", {
              game: game,
              team: game.home_team,
              kit: homeKit,
            });
          }}
        >
          Home Team Crawl
        </GraphicButton>
      )}
      {view === 1 && !selectedPlayer && (
        <GraphicButton
          onClick={() => {
            previewGraphic("TeamCrawl", {
              game: game,
              team: game.away_team,
              kit: awayKit,
            });
          }}
        >
          Away Team Crawl
        </GraphicButton>
      )}

      {view === 0 && !selectedPlayer && (
        <GraphicButton
          onClick={() => {
            previewGraphic("Formation", {
              game: game,
              team: game.home_team,
            });
          }}
        >
          Home Formation
        </GraphicButton>
      )}
      {view === 0 && !selectedPlayer && (
        <GraphicButton
          onClick={() => {
            previewGraphic("Formation", {
              game: game,
              team: game.away_team,
            });
          }}
        >
          Away Formation
        </GraphicButton>
      )}
      {graphicInPreview && (
        <CurrentGraphic>
          {graphicInPreview.name}
          <GraphicButton
            style={{ height: "40px", backgroundColor: "#383f4a" }}
            onClick={() => {
              clearPreview(graphicInPreview.name);
            }}
          >
            CLEAR PVW (CTRL + Q)
          </GraphicButton>

          <GraphicButton
            green
            style={{ height: "40px" }}
            onClick={() => {
              animateGraphic(graphicInPreview.name);
            }}
          >
            IN (F8) or (-)
          </GraphicButton>
          <GraphicButton
            red
            style={{ height: "40px" }}
            onClick={() => {
              animateOffGraphic(graphicInPreview.name);
            }}
          >
            OUT (F9) or (*)
          </GraphicButton>
        </CurrentGraphic>
      )}
      {view === 2 && <Table game={game} />}
    </Main>
  );
}
